// src/components/BiometricLogin.js
import React, { useState } from 'react';
import { handleSignInFromBiometric } from '../../actions/auth-action';
import { connect, useDispatch } from 'react-redux';
import { getLoginOptions } from '../../actions/biometric-action';
import BiometricLoginModal from './BiometricLoginModal';


const BiometricLogin = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
   
    
    </>
  );
};

export default connect(null,{getLoginOptions,handleSignInFromBiometric}) (BiometricLogin);
